/**
 * Utilitários de manipulação e formatação de datas.
 * Garante que datas em formato 'YYYY-MM-DD' (data pura sem horário)
 * não sofram deslocamento de fuso horário (-1 dia no Brasil/UTC-3)
 * ao serem convertidas ou exibidas na interface.
 */

export function formatDateBR(dateStr?: string | null): string {
  if (!dateStr) return '-';
  try {
    const str = String(dateStr).trim();
    if (!str || str === 'null' || str === 'undefined') return '-';

    // Se já estiver formatado como DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
      return str;
    }

    // Se começar com formato de data YYYY-MM-DD
    const datePart = str.split('T')[0].split(' ')[0];
    const parts = datePart.split('-');
    if (parts.length === 3 && parts[0].length === 4) {
      const [year, month, day] = parts;
      if (year && month && day) {
        return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
      }
    }

    // Fallback para datas com timestamp completo
    const d = new Date(str);
    if (!isNaN(d.getTime())) {
      return d.toLocaleDateString('pt-BR');
    }
    return str;
  } catch {
    return String(dateStr);
  }
}

export function formatDateTimeBR(dateTimeStr?: string | null): string {
  if (!dateTimeStr) return '-';
  try {
    const str = String(dateTimeStr).trim();
    if (!str || str === 'null' || str === 'undefined') return '-';

    const d = new Date(str);
    if (!isNaN(d.getTime())) {
      return d.toLocaleString('pt-BR');
    }
    return formatDateBR(str);
  } catch {
    return String(dateTimeStr);
  }
}

export function formatPeriodoBR(start?: string | null, end?: string | null): string {
  const pIni = formatDateBR(start);
  const pFim = formatDateBR(end);
  if (pIni === '-' && pFim === '-') return '-';
  if (pIni === '-') return `Até ${pFim}`;
  if (pFim === '-') return `A partir de ${pIni}`;
  return `${pIni} até ${pFim}`;
}
